module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBoldItalic.fc17ea6.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-SemiBoldItalic.ttf
// module id = 6sRJ
// module chunks = 3